import { BrandFeatures } from 'apiTypes/BrandFeatures'

export type DataToReview = 'both' | 'budget' | 'expenses' | 'income'

export const getDataToReview = (brandFeatures: Array<BrandFeatures>): DataToReview => {
	const hasIncome = brandFeatures.includes(BrandFeatures.Income)
	const hasExpenses = brandFeatures.includes(BrandFeatures.Expenses)

	if (hasIncome && hasExpenses) return 'both'
	if (hasIncome) return 'income'
	if (hasExpenses) return 'expenses'
	return 'budget'
}
